import { useTranslation } from 'react-i18next'
import mapValues from 'lodash-es/mapValues'

import { getFlatProfilePathname } from '../../../../../utils/link'
import { BirdviewAnnouncementsWidget } from '../../../BirdviewAnnouncementsWidget'
import { BirdviewDocumentsWidget } from '../../../BirdviewDocumentsWidget'
import { BirdviewHomeWidget } from '../../../BirdviewHomeWidget'
import { BirdviewMessagesWidget } from '../../../BirdviewMessagesWidget'
import { BirdviewPropertiesWidget } from '../../../BirdviewPropertiesWidget'
import { BirdviewServiceRequestsWidget } from '../../../BirdviewServiceRequestsWidget'
import { BIRDVIEW_SECTION_TARGET } from '../../../DashboardBirdview.constants.targets'
import {
  BIRDVIEW_DWELLER_WIDGET_TITLE_KEY,
  BirdviewDwellerWidget,
} from '../../BirdviewDweller.constants'
import { getBirdviewDwellerSections } from '../../BirdviewDweller.utils'

import FlatIcon from '../../../../../icons/flat.svg'

export function useBirdviewDwellerWidgets({ sections, onNavigate }) {
  const { t } = useTranslation()

  const { announcements, documents, home, messages, objects, requests } =
    getBirdviewDwellerSections(sections)

  const widgetTitles = mapValues(BIRDVIEW_DWELLER_WIDGET_TITLE_KEY, key =>
    t(key)
  )

  const widgets = {
    [BirdviewDwellerWidget.Announcements]: dragHandleProps => (
      <BirdviewAnnouncementsWidget
        dragHandleProps={dragHandleProps}
        section={announcements}
        title={widgetTitles[BirdviewDwellerWidget.Announcements]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewDwellerWidget.Documents]: dragHandleProps => (
      <BirdviewDocumentsWidget
        dragHandleProps={dragHandleProps}
        section={documents}
        title={widgetTitles[BirdviewDwellerWidget.Documents]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewDwellerWidget.Home]: dragHandleProps => (
      <BirdviewHomeWidget
        dragHandleProps={dragHandleProps}
        section={home}
        title={widgetTitles[BirdviewDwellerWidget.Home]}
      />
    ),
    [BirdviewDwellerWidget.Messages]: dragHandleProps => (
      <BirdviewMessagesWidget
        dragHandleProps={dragHandleProps}
        section={messages}
        title={widgetTitles[BirdviewDwellerWidget.Messages]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewDwellerWidget.Objects]: dragHandleProps => (
      <BirdviewPropertiesWidget
        Icon={FlatIcon}
        dragHandleProps={dragHandleProps}
        getProfilePathname={getFlatProfilePathname}
        section={objects}
        showAllTarget={BIRDVIEW_SECTION_TARGET.dwellerObjects}
        title={widgetTitles[BirdviewDwellerWidget.Objects]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewDwellerWidget.Requests]: dragHandleProps => (
      <BirdviewServiceRequestsWidget
        actionKey='DashboardBirdview.RowActionViewKey'
        dragHandleProps={dragHandleProps}
        section={requests}
        showAllTarget={BIRDVIEW_SECTION_TARGET.requests}
        title={widgetTitles[BirdviewDwellerWidget.Requests]}
        onNavigate={onNavigate}
      />
    ),
  }

  return { widgets, widgetTitles }
}
